import safeStorage from "./storage";

/**
 * 주문 완료 스냅샷. 통합안(2026-07-02): 전체 주문 내용이 아니라 orderId만 보관하고,
 * 다시보기 화면이 pikashop을 orderId로 조회(서버가 txId 해석 → 세션 목록)한다.
 */
export type LastOrder = {
    orderId: number;   // pikashop order.id (앱이 place 후 안정적으로 보유)
    shopId: string;    // pikashop shopid (세션 조회 URL용)
    tableNo: string;
    placedAt: number;  // epoch ms
};

const key = (uuid: string) => `lastOrder:${uuid}`;

export function saveLastOrder(uuid: string, o: LastOrder): void {
    try {
        safeStorage.setItem(key(uuid), JSON.stringify(o));
    } catch {
        // storage 차단(iOS private mode 등) — 무시(다시보기만 불가, 주문엔 무영향)
    }
}

export function loadLastOrder(uuid: string): LastOrder | null {
    try {
        const raw = safeStorage.getItem(key(uuid));
        return raw ? (JSON.parse(raw) as LastOrder) : null;
    } catch {
        return null;
    }
}

/** 완료 마커: reload/bfcache 가드가 "완료된 세션인지" 판정에 사용. */
export function hasCompletedOrder(uuid: string): boolean {
    return loadLastOrder(uuid) != null;
}

/**
 * 완료 마커 제거. safeStorage에 removeItem이 없어 ""로 비운다(loadLastOrder가 ""→null 처리).
 * fresh 스캔으로 새 주문 세션을 시작할 때 호출 → 지난 방문의 마커가 이번 세션의
 * '주문 전 reload'를 오탐(재주문 방지 가드 오작동)하지 않게 한다.
 */
export function clearLastOrder(uuid: string): void {
    try {
        safeStorage.setItem(key(uuid), "");
    } catch {
        // storage 차단 — 무시
    }
}
